/* (ignored) */


//////////////////
// WEBPACK FOOTER
// fs (ignored)
// module id = 1
// module chunks = 0